<template>
    <div class="footer_nav">
        <md-tab-bar v-model="current" :items="items" :has-ink="false" @change="onChange">
            <template slot="item" slot-scope="{ item }">
                <div class="custom-item">
                    <div class="icon">
                        <md-icon :name="item.icon" />
                    </div>
                    <div class="text">
                        <span v-text="item.label"></span>
                    </div>
                </div>
            </template>
        </md-tab-bar>
    </div>
</template>
  
<script>
export default {
    name: 'navbar',
    data() {
        return {
            current: 'home',
            items: [
                {
                    name: 'home',
                    label: 'Home',
                    icon: 'home'
                },
                {
                    name: 'transaction',
                    label: 'Transaction',
                    icon: 'switch'
                },
                {
                    name: 'my',
                    label: 'Mine',
                    icon: 'user',
                }
            ],
        }
    },
    mounted() {
        const rname = this.$route.name
        let item = this.items.filter((i) => {
            return rname === i.name;
        })[0];
        if (item) {
            this.current = item.name;
        }

    },
    methods: {
        onChange(item, index, prevIndex) {
            console.log(item, index, prevIndex)
            this.$router.push({ "name": item.name })
        },
    }
}

</script>
<style scoped>
.footer_nav {
    text-align: center;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 999;
}

.custom-item {
    text-align: center;
}
.footer_nav>>> .md-tab-bar-end {
    height: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue